export const easyCompliance = {
  apiKey: "API Key",
  apiKeyHelp:
    "Eindeutiger Schlüssel für die Authentifizierung. Wird Ihnen vom Kundendienst mitgeteilt. Ohne API-Key ist ein Zugriff auf die API nicht möglich"
};
